import { LogLevel } from 'loglayer';

export type MessageDataType = string | number | boolean | null | undefined;
export type LogMeta = Record<string, unknown>;
export type LogFunction = (message: MessageDataType, meta?: LogMeta) => void;
export type AppLogger = Record<LogLevel, LogFunction>;

export enum Runtime {
	Edge = 'edge',
	Server = 'server',
	Client = 'client',
}
